export default {
  'login.userName.required': 'Please enter your User Name!',
  'login.admin.userName.required': 'Please enter your User Name!',
  'login.newpassword.required': 'Please input your new password',
  'login.confirmpassword.placeholder': 'Confirm your password',
  'login.userName': 'User Name',
  'login.admin.userName': 'User Name',
  'FAQ.PopularQuestions': 'Package',
  'overview.accountManagerName': 'Account Manager Name',
  'overview.AccountManagerEmail': 'Account Manager Email',
  'overview.AccountManagerContactNumber': 'Account Manager Contact Number',
  'account.autoDebit': 'Auto Debit',
  'memberMgr.mobileNumber': 'Mobile Number',
  'memberMgr.lineStatus': 'Status',
  'memberMgr.subscriberDetail': 'Subscriber Detail',
  'memberMgr.privateAccount': 'Billing Account',
  'memberMgr.suspensionUnderRequest': 'Voluntary Suspension',
  'memberMgr.simCardLost': 'SIM Lost & Stolen',
  'memberMgr.reactivationUnderRequest': 'Reactivation',
  'memberMgr.simCardRestore': 'SIM Restoration',
  'overview.upload.error': 'You can only upload JPG/PNG/GIF file!',
  'systemLog.userCode': 'User ID',
  'account.country': 'Country',
  'account.postcode': 'Postcode',
  'account.city': 'City',
  'account.state': 'State',
  'account.address': 'Address',
  'account.malaysia': 'Malaysia',
  'account.postcodeResult': 'Postcode does not exist',
  'account.postcodeValid': 'Please enter a 5-digit number postcode.',
  'memberMgr.referenceCode': 'Reference Code',
  'memberMgr.newSelectMsisdn': 'Select MSISDN',
  'memberMgr.newSelectOffer': 'Select Offer',
  'memberMgr.newSelectAddOn': 'Select Add-On',
  'memberMgr.addNewConnection': 'Add New Connection(OM)',
  'memberMgr.newConnection': 'New Connection',
  'billMgr.paymentCounter': 'Payment Counter',
  'billMgr.onlineBanking': 'Online Banking',
  'billMgr.pay': 'Pay',
  'debit.neverForget': 'Never Forget To Pay Your Bills Again',
  'debit.signUp': 'Sign Up For Auto Debit Online Today!',
  'debit.GetYouBill':
    'Get your bill deducted automatically from your credit card every month with Auto Debit service.',
  'debit.easiestWay': "It's the easiest way to pay your U Mobile bill.",
  'debit.step1': 'Step 1',
  'debit.step2': 'Step 2',
  'debit.step3': 'Step 3',
  'debit.step1Text': 'Click the button\nbelow to sign-up for\n Auto Debit.',
  'debit.step2Text':
    'Key in your personal\ndetails and credit\ncard information.',
  'debit.step3Text': "Once successful\nyou'll receive a\nconfirmation from us.",
  'debit.note':
    'Note: Pre-authorisation temporary hold of RM1.00 applies to verify\n your Debit/Credit Card is active. It will take a few days for the\namount to be released back to you.',
  'debit.letsGo': "Let's Go",
  'debit.alreadysianed': 'Already signed up for Auto Debit?',
  'debit.footer':
    'Click the button above to update or make changes to your Auto Debit subscription.',
  'billMgr.credit/DebitCard': 'Credit/Debit Card',
  'billMgr.back': 'Back',
  'billMgr.selectPaymentTip': 'Please select your preferred mode of payment',
  'billMgr.payNow': 'Pay Now',
  'memberMgr.operateSuccess': 'Request submit successfully.',
  'order.select.member': 'Select Service Number',
  'common.userId': 'User ID',
  'common.phoneNumber': 'Phone Number',
  'common.portalAccess': 'Portal Access',
  'common.creationDate': 'Creation Date',
  'common.newAdminUser': 'New Admin User',
  'common.adminPortal': 'Admin Portal',
  'common.userPortal': 'User Portal',
  'common.addAdminUser': 'Add Admin User',
  'common.phoneValid': 'Phone Number must be a number',
  'common.userName': 'User Name',
  'common.lengthValid': 'The maximum length of the field is {length}',
  'bill.paymentResultSuccessTitle': 'Thank You For Your Payment',
  'bill.paymentResultFailTitle': 'Payment Unsuccessful',
  'bill.paymentResultSuccessDesc':
    'Please check your balance, if it is not updated please call our customer services at +6018 388 1318 for assistance. Payment notification will be sent to your email.',
  'bill.paymentResultFailDesc':
    'Your transaction was unsuccessful. Please try again. lf you encounter the same error, check your card status with the bank provider or call our customer services at +6018 388 1318 for assistance.',
  'bill.paymentResultTitle': 'Bill Payment',
  'bill.backHome': 'Back To Home',
  'bill.print': 'Print Receipt',
  'bill.savePDF': 'Save as PDF',
  'bill.paymentStatus': 'Payment Status',
  'bill.dateandTime': 'Date & Time',
  'bill.orderNumber': 'Order Number',
  'bill.transactionID': 'Transaction ID',
  'bill.paymentDesc': 'Payment Description',
  'bill.mobileNumberForPaymentNotification':
    'Mobile Number for Payment Notification',
  'bill.paymentAmount': 'Payment Amount',
  'bill.cardType': 'Card Type',
  'bill.paymentDescription': 'Pay Bill',
  'bill.processing': 'Processing',
  'bill.transactionSuccess': 'Transaction Completed',
  'bill.transactionFail': 'Transaction Failed',
  'bill.refunded': 'Refunded',
  'bill.bank': 'Bank',
  'bill.notice': 'Important Notice',
  'bill.pleaseEnsure': `: Please ensure all outstanding bills are settled to prevent service interruption.`,
  'account.acctValidatorLable': 'Enter at least {count} characters',
  'FAQ.keyWordsLimit': 'Each keyword cannot exceed {count} characters',
  'memberMgr.agreementInfo': 'Change Offer is not allowed as the existing contract pertaining to the original main offer remains valid.'
};
